import { render, staticRenderFns } from "./provideImageDialog1.vue?vue&type=template&id=116f2131&scoped=true&"
import script from "./provideImageDialog1.vue?vue&type=script&lang=js&"
export * from "./provideImageDialog1.vue?vue&type=script&lang=js&"
import style0 from "./provideImageDialog1.vue?vue&type=style&index=0&id=116f2131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f2131",
  null
  
)

export default component.exports